import React from 'react' // EL PRIMER PASO ES IMPORTAR REACT A EL COMPONENTE

//  <h1 id="Title">{ this.props.title }</h1> EJEMPLO DE : props 

export default class Title extends React.Component
{
  render( )
  {
    return(
                   <div>
                         <h1 id="Title">El Paso TX Best Places</h1>
                         <p id="Description">Discover the best places in.... El Paso TX</p>
                   </div>
               )
  }
}



// WEBPACK FOOTER //
// ./src/components/Title.js